import React, { useEffect } from "react";
/* eslint import/no-webpack-loader-syntax: off */

//@ts-expect-error
import css from "!raw-loader!./App.css";

//UX
import TourEditPage from "./components/TourEditPage/TourEditPage.tsx";

//QUERY
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { client } from "./Query.ts";

import TourViewer from "./components/TourViewer/TourViewer.tsx";
import { ErrorBoundary } from "react-error-boundary";

import { jwtDecode } from "jwt-decode";
import { Jwt } from "./Types.ts";
import {
  useJWTStore,
  useParametersStore,
  useTourIDStore,
  useViewerStore,
} from "./api/Zustand.ts";

export const OPENAIENABLED = false;

function App({
  tourid,
  userid,
  iseditor,
  jwt,
  lang,
}: {
  tourid: number;
  userid: number;
  iseditor: boolean;
  jwt?: string;
  lang: "it" | "en" | undefined;
}) {
  const { setTourID: test } = useTourIDStore();

  React.useEffect(() => {
    test(tourid);
  }, [tourid, test]);

  const { viewer } = useViewerStore();
  const { setUserID, setTourID, setLang } = useParametersStore();

  const [params, setParams] = React.useState<Jwt | undefined>(undefined);

  useEffect(() => {
    if (jwt) {
      useJWTStore.setState({ jwt: jwt });
      const decoded: Jwt = jwtDecode(jwt);
      return setParams(decoded);
    }
  }, [jwt]);

  useEffect(() => {
    if (tourid) setTourID(tourid);
    else if (params && params.tourId) setTourID(JSON.parse(params.tourId));
  }, [params?.tourId, tourid, params, setTourID]);

  useEffect(() => {
    if (userid) setUserID(userid);
    else if (params && params.userId) setUserID(JSON.parse(params.userId));
  }, [params?.userId, userid, params, setUserID]);

  React.useEffect(() => {
    if (lang === "en") {
      setLang(lang);
    } else if (lang) setLang("it");
    else if (
      (params && params.lang && params.lang === "it") ||
      params?.lang === "en"
    )
      setLang(params?.lang);
  }, [params, lang, setLang]);

  const usedTourID = React.useMemo(() => {
    if (tourid) return tourid;
    else if (params) return JSON.parse(params.tourId);
  }, [tourid, params]);

  const usedUserID = React.useMemo(() => {
    if (userid) return userid;
    else if (params) return JSON.parse(params.userId);
  }, [userid, params]);

  return (
    <QueryClientProvider client={client}>
      <style>{css}</style>

      <div className="App">
        {!iseditor || viewer ? (
          <ErrorBoundary
            fallback={
              <div
                style={{
                  background: "#242424",
                  color: "white",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <h1>
                  <pre>Error</pre>
                </h1>
              </div>
            }
          >
            {/* <HOOKFORMTEST /> */}

            <TourViewer tourID={usedTourID} userID={usedUserID} />
          </ErrorBoundary>
        ) : (
          <ErrorBoundary
            fallback={
              <div
                style={{
                  background: "#242424",
                  color: "white",
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <h1>
                  <pre>Error</pre>
                </h1>
              </div>
            }
          >
            {/* <DraggableTest /> */}
            <TourEditPage
              tourID={usedTourID}
              // setViewer={setViewer}
            />
          </ErrorBoundary>
        )}
      </div>
      {/* <ReactQueryDevtools /> */}
    </QueryClientProvider>
  );
}

export default App;
